/**
 * inline-variants.js  —  Derpy Cards
 *
 * Install: upload as assets/inline-variants.js, then add before </body> in theme.liquid:
 *   <script src="{{ 'inline-variants.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function dispatch(eventName) {
    document.dispatchEvent(new CustomEvent(eventName, { bubbles: true }));
  }

  // ── Find the price element in .product-card-info for a given .inline-variants wrapper ──
  // The inline-variants div is now inside .product-card-info itself.
  // Walk up to the card and find the price element that precedes .inline-variants.
  function getPriceEl(inlineWrapper) {
    // .inline-variants is now a direct child of .product-card-info
    // The price is a sibling earlier in the same container
    var info = inlineWrapper.closest('.product-card-info');
    if (!info) return null;
    // The theme renders: <span class="price"><span class="amount">$X.XX</span></span>
    return info.querySelector('.amount') || info.querySelector('.price');
  }

  // ── On load: set each card's price to the highest available variant price ────────
  function initPrices() {
    document.querySelectorAll('.inline-variants[data-initial-price]').forEach(function (wrapper) {
      var rawPrice = parseInt(wrapper.dataset.initialPrice, 10);
      if (isNaN(rawPrice) || rawPrice === 0) return;
      var priceEl = getPriceEl(wrapper);
      if (priceEl) priceEl.textContent = formatMoney(rawPrice);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrices);
  } else {
    initPrices();
  }

  // ── Radio change → update button variant ID + price in card-info ──────────────
  document.addEventListener('change', function (e) {
    var radio = e.target;
    if (!radio.matches || !radio.matches('.inline-variants input[type="radio"]')) return;

    var wrapper = radio.closest('.inline-variants');
    if (!wrapper) return;

    var btn = wrapper.querySelector('.inline-atc-btn');
    var isAvailable = radio.dataset.available === 'true';
    var rawPrice = parseInt(radio.dataset.priceRaw, 10);

    // Update the button's stored variant ID
    if (btn) {
      btn.dataset.variantId = radio.value;
      btn.disabled = !isAvailable;
      btn.textContent = isAvailable ? 'Add to cart' : 'Sold out';
    }

    // Update the price in .product-card-info (the existing theme price element)
    if (!isNaN(rawPrice)) {
      var priceEl = getPriceEl(wrapper);
      if (priceEl) priceEl.textContent = formatMoney(rawPrice);
    }
  });

  // ── Add to Cart button click → AJAX, then open Aeroform cart drawer ──────────
  document.addEventListener('click', function (e) {
    var btn = e.target;
    if (!btn.matches || !btn.matches('.inline-atc-btn')) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    })
    .then(function () {
      btn.textContent = 'Added!';
      // Refresh cart drawer contents, then open it
      dispatch('cart:refresh');
      setTimeout(function () { dispatch('cart-drawer:open'); }, 80);
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 2000);
    })
    .catch(function (err) {
      console.error('[inline-variants] Cart add error:', err);
      btn.disabled = false;
      btn.textContent = originalText;
    });
  });

})();
